<script setup>
import {
  onMounted, onUnmounted, ref,
} from 'vue';
import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';

const props = defineProps({
  settings: {
    type: Object,
    default() {
      return {
        showCaptcha: false,
        simulateCaptchaMode: 'off',
        apiEndpoint: undefined,
        sitekey: undefined,
      };
    },
  },
  error: undefined,
  errorUnlocked: {
    type: Boolean,
    default: false,
  },
});

const captcha = ref();
const widget = ref();

const emit = defineEmits(['complete']);
const solution = defineModel('solution', { type: String });

function complete(event) {
  solution.value = event.detail.response;
  emit('complete');
}

function reset() {
  if (widget.value) {
    widget.value.reset();
    solution.value = undefined;
  }
}
defineExpose({ reset });

function simulate() {
  solution.value = 'simulated-response';
  emit('complete');
}

onMounted(() => {
  if (widget.value) {
    widget.value.reset();
  }

  if (!widget.value && captcha.value) {
    const sdk = new FriendlyCaptchaSDK();

    widget.value = sdk.createWidget({
      apiEndpoint: props.settings.apiEndpoint,
      element: captcha.value,
      sitekey: props.settings.sitekey,
      formFieldName: 'captcha-solution',
    });

    widget.value.addEventListener('frc:widget.complete', complete);
  }
});

onUnmounted(() => {
  if (widget.value) {
    widget.value.destroy();
  }
});
</script>

<template>
  <cmpr-form-hint
    v-if="settings.showCaptcha && props.errorUnlocked && props.error"
    class="mb-50 mt-70"
    variant="error"
  >
    {{ props.error }}
  </cmpr-form-hint>
  <slot />
  <input
    v-if="settings.simulateCaptchaMode === 'auto' || settings.simulateCaptchaMode === 'manual'"
    id="captcha-solution"
    name="captcha-solution"
    type="hidden"
    @change="simulate"
  >
  <div
    v-else-if="settings.showCaptcha"
  >
    <div
      ref="captcha"
      class="frc-captcha"
    />
  </div>
</template>
